<template>
  <div class="block">
    <div class="bigImg">New Technology Creates New World</div>
    <div id="Business-Introduction" class="Business-Introduction">
      <div class="title">Business Introduction</div>
      <div class="card">
        <div class="card-item" v-for="(item, index) in card" :key="index">
          <img class="card-item-img" :src="item.url" />
          <div class="card-item-title">{{ item.title }}</div>
          <div class="card-item-content">{{ item.content }}</div>
        </div>
      </div>
    </div>
    <div class="Business-Model" id="Business-Model">
      <div class="model-top">
        <div class="title">Business Model</div>
        <div class="model-content">
          Credpay is a new technology platform based on B2B2C model. Provide
          intelligent solutions for financial institutions, scene merchants and
          various users. After rapid development, we have helped many
          enterprises or institutions to quickly achieve digital transformation
          and upgrading.
        </div>
      </div>
      <div class="model-bottom">
        <div style="display: table">
          <div class="leftImg">
            New Technology<br />
            Creates New World
          </div>
        </div>
        <div class="rightImg">
          <div>
            <img class="rightImgTop" :src="model2" />
          </div>
          <div>
            <img class="rightImgBottom" :src="model3" />
            <img
              style="margin-left: 15rem"
              class="rightImgBottom"
              :src="model4"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="Cooperative-Institutions" id="Cooperative-Institutions">
      <div class="title">Cooperative Institutions</div>
      <div class="Institutions">
        <img
          class="InstitutionsImg"
          v-for="(item, index) in Institutions"
          :key="index"
          :src="item"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Banner",
  created() {},
  data() {
    return {
      model1: require("../assets/img/home/model1.png"),
      model2: require("../assets/img/home/model2.png"),
      model3: require("../assets/img/home/model3.png"),
      model4: require("../assets/img/home/model4.png"),
      card: [
        {
          url: require("../assets/img/home/card1.png"),
          title: "Intelligence Solutions",
          content:
            "Link financial institutions with SMEs and individual users to provide intelligent solutions.",
        },
        {
          url: require("../assets/img/home/card2.png"),
          title: "Technology Enablement",
          content:
            "Export technical solutions such as intelligent decision-making and accurate customer acquisition to financial institutions to help them achieve transformation and upgrading.",
        },
        {
          url: require("../assets/img/home/card3.png"),
          title: "Scenario Solution",
          content:
            "Deeply cultivate AI technology, accurately identify according to different scenarios, and help organizations in various industries realize digitalization.",
        },
      ],
      Institutions: [
        require("../assets/img/home/Institutions1.png"),
        require("../assets/img/home/Institutions2.png"),
        require("../assets/img/home/Institutions3.png"),
        require("../assets/img/home/Institutions4.png"),
        require("../assets/img/home/Institutions5.png"),
        require("../assets/img/home/Institutions6.png"),
        require("../assets/img/home/Institutions7.png"),
        require("../assets/img/home/Institutions8.png"),
        require("../assets/img/home/Institutions9.png"),
        require("../assets/img/home/Institutions10.png"),
        require("../assets/img/home/Institutions11.png"),
        require("../assets/img/home/Institutions12.png"),
      ],
    };
  },
  methods: {},
};
</script>

<style scoped>
.block {
  padding-top: 89rem;
  font-family: PingFangSC;
  flood-color: #333333;
}
.bigImg {
  width: 100%;
  height: 622rem;
  font-size: 50rem;
  color: #ffffff;
  background: url("../assets/img/home/mainImg.png") no-repeat 100%/100%;
  text-align: center;
  line-height: 622rem;
}
.Business-Introduction {
  width: 100;
  height: 616rem;
  background-color: #f5f5f5;
}
.title {
  font-size: 24rem;
  margin-left: 285rem;
  line-height: 106rem;
  margin-right: 53rem;
  font-weight: 700;
}
.card {
  height: 380rem;
  display: flex;
  justify-content: center;
}
.card-item {
  width: 250rem;
  margin-left: 120rem;
  background-color: #ffffff;
  text-align: center;
}
.card-item-img {
  width: 210rem;
  height: 150rem;
}
.card-item-title {
  font-size: 18rem;
  margin-top: 10rem;
  font-weight: 700;
}
.card-item-content {
  margin-left: 5rem;
  padding: 20rem;
  text-align: left;
  font-size: 12rem;
  margin-top: 16rem;
}
.Business-Model {
  height: 764rem;
}
.model-top {
  display: flex;
}
.model-content {
  width: 520rem;
  font-size: 18rem;
  margin-top: 38rem;
  margin-left: 110rem;
}
.model-bottom {
  display: flex;
  justify-content: center;
  margin-top: 50rem;
}
.leftImg {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  font-size: 32rem;
  color: #ffffff;
  width: 417rem;
  height: 430rem;
  background: url("../assets/img/home/model1.png") no-repeat 100%/100%;
}
.rightImg {
  margin-left: 36rem;
}
.rightImgTop {
  height: 193rem;
  width: 417rem;
}
.rightImgBottom {
  margin-top: 35rem;
  width: 200rem;
  height: 200rem;
}
.Cooperative-Institutions {
  /* height: 410rem; */
  background-color: #f5f5f5;
  padding-bottom: 80rem;
}
.InstitutionsImg {
  width: 200rem;
  height: 67rem;
  margin-top: 36rem;
}
.Institutions {
  margin-left: 350rem;
  width: 740rem;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
</style>


// WEBPACK FOOTER //
// src/page/Home.vue



// WEBPACK FOOTER //
// src/page/Home.vue